// @ts-ignore
import japaneseMessages from 'ra-language-japanese';

export const messages = {
  simple: {
    action: {
      close: '閉じる',
      resetViews: 'ビューをリセット',
    },
    'create-post': '新規投稿',
    login: {
      title: 'ログイン',
    },
    email: 'メールアドレス',
    password: 'パスワード',
    role: '役割',
    admin: '管理者',
    guest: 'ゲスト',
    owner: 'オーナー',
    required_email: 'メールアドレスを入力してください',
    logout: 'ログアウト',
    checked_in: 'チェックイン',
    today: '今日',
    yesterday: '昨日',
    last_week: '先週',
    add_new_field: '項目を追加',
    new_field_name: '新しいフィールド名',
    added_fields: '追加されたフィールド',
    deleted_fields: '削除されたフィールド',
    renamed_fields: '名前が変更されたフィールド',
    confirm_template_changes: 'テンプレートの変更を確認',
    reselect: '再選択',
    select_a_photo: '写真を選択',
    field_name_is_required: 'フィールド名は必須です',
    image_is_required: '画像は必須です',
  },
  form_submission: {
    share: {
      button: '共有',
      title: 'フォーム申請',
      date: '申請日',
      copied: 'クリップボードにコピーしました',
      error: '共有に失敗しました',
    },
    fields: {
      id: 'ID',
      template_name: '名前',
      image: '画像',
      submitted_data: '射特値',
      actions: 'アクション',
      client: 'クライアント',
      created_at: '作成日時',
      updated_at: '更新日時',
      name: '名前',
      form_extract_key: 'フォーム抽出キー',
      expected_data: '期待値',
      note: 'コメント',
    },
    actions: {
      view_detail: '詳細を見る',
      delete: '削除',
      edit: '編集',
    },
    notification: {
      created_success: 'フォーム申請が正常に作成されました',
      created_error: 'フォーム申請の作成中にエラーが発生しました',
      deleted: '削除しました',
      deleted_error: '削除中にエラーが発生しました',
      updated_success: 'フォーム申請が正常に更新されました',
      updated_error: 'フォーム申請の更新中にエラーが発生しました',
    },
    show: {
      title: 'フォーム申請詳細',
      basic_info: '基本情報',
      template_info: 'テンプレート情報',
    },
    create: {
      title: '新しいフォーム申請を作成',
      template_selection: 'テンプレート選択',
      client_info: 'クライアント情報',
      submitted_data: '送信データ',
      submitted_data_help: 'フォームデータをJSON形式で入力してください',
      image_upload: '画像アップロード',
      form_info: 'フォーム情報',
    },
    edit: {
      title: 'フォーム申請を編集',
      image_upload: '画像アップロード',
      form_info: 'フォーム情報',
      no_image: '画像がありません',
    },
  },
  prompts: {
    list: {
      title: 'プロンプト',
    },
    fields: {
      version: 'バージョン',
      prompt: 'プロンプト内容',
      actions: 'アクション',
      updated_at: '更新日',
      key: 'キー',
    },
    actions: {
      edit: '編集',
    },
  },
  resources: {
    user: {
      name: 'ユーザー |||| ユーザー',
      fields: {
        name: '名前',
        role: '役割',
        display_name: '表示名',
        email: 'メールアドレス',
        first_name: '名',
        last_name: '姓',
        plan: 'プラン',
        current_period_start: '現在の期間開始',
        current_period_end: '現在の期間終了',
      },
    },

    guest: {
      name: 'ゲスト',
      fields: {
        create_key: 'キーを作成',
        name: '名前',
        position: '役職',
        company_name: '会社名',
        work_phone: '仕事の電話番号',
        mobile: '携帯電話',
        updated_at: '更新日時',
        email: 'メールアドレス',
        fax: 'FAX',
        website: 'ウェブサイト',
        others: 'その他',
        business_card: '名刺',
        name_jp: '名前（日本語）',
        name_en: '名前（英語）',
        title: 'タイトル',
        company_address: '会社住所',
        company_short_name: '会社略称',
      },
      actions: {
        create_key: '追加',
      },
    },
    form_template: {
      name: 'フォームテンプレート |||| フォームテンプレート',
      fields: {
        name: 'テンプレート名',
        description: '説明',
        form: 'フォーム',
        updated_at: '更新日時',
        form_fields: 'フォームフィールド',
        imageKey: 'サムネイル',
      },
      notification: {
        saved_success: '保存に成功しました',
        saved_error: '保存中にエラーが発生しました',
        deleted_success: '削除に成功しました',
        deleted_error: '削除中にエラーが発生しました',
        confirm_delete: '削除してもよろしいですか？',
      },
    },
    client: {
      name: 'クライアント |||| クライアント',
      fields: {
        name: '名前',
        description: '説明',
        chatwork_api_token: 'Chatwork API トークン',
        chatwork_room: 'Chatwork ルーム',
        slack_token: 'Slack トークン',
        slack_channel_id: 'Slack チャンネル ID',
        updated_by: '更新者',
        updated_at: '更新日時',
      },
    },
    subscriptions: {
      name: 'サブスクリプション |||| サブスクリプション',
      fields: {
        plan_id: 'プラン ID',
        current_period_start: '現在の期間開始',
        current_period_end: '現在の期間終了',
        client: 'クライアント',
        user: 'ユーザー',
        first_name: '名',
        last_name: '姓',
        email: 'メールアドレス',
        display_name: '表示名',
        updated_by: '更新者',
        updated_at: '更新日時',
        created_at: '作成日時',
        created_by: '作成者',
      },
    },
    setting: {
      name: '設定',
      fields: {
        name: '名前',
        value: '値',
        description: '説明',
        updated_at: '更新日時',
        key: 'キー',
        updated_by: '更新者',
      },
    },
    log: {
      name: 'ログ',
      fields: {
        title: 'タイトル',
        message: 'メッセージ',
        level: 'レベル',
        module: 'モジュール',
        created_by: '作成者',
        created_at: '作成日時',
      },
    },
    user_device_tokens: {
      name: 'ユーザーデバイストークン |||| ユーザーデバイストークン',
      fields: {
        id: 'ID',
        user_id: 'ユーザー ID',
        device_id: 'デバイス ID',
        fcm_token: 'FCM トークン',
        is_subscribed: '購読中',
        created_at: '作成日時',
        updated_at: '更新日時',
      },
    },
    notifications: {
      name: '通知 |||| 通知',
      fields: {
        id: 'ID',
        title: 'タイトル',
        text: 'テキスト',
        status: 'ステータス',
        created_at: '作成日時',
        updated_at: '更新日時',
        scheduled_at: 'スケジュール日時',
      },
    },
    notification_details: {
      name: '通知詳細 |||| 通知詳細',
      fields: {
        id: 'ID',
        notification_id: '通知 ID',
        payload: 'ペイロード',
        tokens: 'トークン',
        status: 'ステータス',
        created_at: '作成日時',
        updated_at: '更新日時',
      },
    },
    common: {
      save_success: '保存に成功しました',
      saved_error: '保存中にエラーが発生しました',
      main_information: '主な情報',
    },
    form_submission: {
      name: '書類',
      fields: {
        id: 'ID',
        template_name: 'テンプレート名',
        image: '画像',
        submitted_data: '送信データ',
        actions: 'アクション',
        client: 'クライアント',
        created_at: '作成日時',
        updated_at: '更新日時',
        expected_data: '期待値',
        note: 'コメント',
      },
      actions: {
        view_detail: '詳細を見る',
        delete: '削除',
        edit: '編集',
      },
      show: {
        title: 'フォーム申請詳細',
        basic_info: '基本情報',
        template_info: 'テンプレート情報',
      },
      create: {
        title: '新しいフォーム申請を作成',
        template_selection: 'テンプレート選択',
        client_info: 'クライアント情報',
        submitted_data: '送信データ',
        submitted_data_help: 'フォームデータをJSON形式で入力してください',
      },
      edit: {
        title: 'フォーム申請を編集',
        image_upload: '画像アップロード',
        form_info: 'フォーム情報',
        no_image: '画像がありません',
      },
      notification: {
        updated_success: 'フォーム申請が正常に更新されました',
        updated_error: 'フォーム申請の更新中にエラーが発生しました',
      },
      errors: {
        loading_image: '画像の読み込みエラー',
        no_analysis_queue: '分析キューが見つかりません',
        no_image: '分析キューに画像が見つかりません',
      },
    },
    prompt_templates: {
      name: 'プロンプト',
    },
    results: {
      name: '結果一覧',
    },
  },
  user: {
    list: {
      search: '検索',
    },
    form: {
      summary: '概要',
      security: 'セキュリティ',
    },
    action: {
      save_and_add: '保存して追加',
      save_and_show: '保存して表示',
    },
  },
  ...japaneseMessages,
  ra: {
    ...japaneseMessages.ra,
    saved_queries: {
      label: '保存したクエリ',
      query_name: 'クエリ名',
      query: 'クエリ',
      help: '現在のクエリを後で使用するために保存します',
    },
    action: {
      ...japaneseMessages.ra.action,
      search: '検索',
      create: '作成',
      export: 'エクスポート',
      edit: '編集',
      confirm: '確認',
      delete: '削除',
      cancel: 'キャンセル',
      save: '保存',
    },
    page: {
      ...japaneseMessages.ra.page,
      empty: 'データが見つかりません',
      invite: '招待',
    },
    message: {
      ...japaneseMessages.ra.message,
      bulk_delete_content: '選択したデータを削除します。よろしいですか？',
    },
  },
};

export default messages;
